module.exports = __webpack_public_path__ + "static/img/1.2edeca47.png";